import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export interface ArticleSheetObj {
  article_sheet_id: string;
  gmc1: string;
  gmc1_en: string
  gmc2: string;
  gmc2_en: string;
  gmc3: string;
  gmc3_en: string;
  gmc4: string;
  gmc4_en: string;
  gmcce?: string;
  gmcce_en?: string;
  hauteur?: string;
  id: number;
  itg_number: string;
  its_number: string;
  label: string;
  label_en: string;
  largeur?: string;
  longueur?: string;
  manutan_link: string;
  mig?: string;
  pdv_filiale?: string;
  pdv_final?: string;
  photos: string[];
  pid_number: string;
  poids?: string;
  [key: string]: any;
}

export interface StockItem {
  article_sheet: number;
  article_sheet_obj: ArticleSheetObj;
  available_stock: number;
  confirmed_reserved_stock: number;
  id: number;
  pending_stock: number;
  temporary_reserved_stock: number;
  total_stock: number;
}

interface StocksState {
  items: StockItem[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: StocksState = {
  items: [],
  status: 'idle',
  error: null,
};

export const fetchStocks = createAsyncThunk<StockItem[]>(
  'stocks/fetchStocks',
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetch(process.env.REACT_APP_API_URL!);
      if (!res.ok) throw new Error('Erreur API');
      return await res.json();
    } catch (err: any) {
      return rejectWithValue(err.message);
    }
  }
);

const stocksSlice = createSlice({
  name: 'stocks',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchStocks.pending, state => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchStocks.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload;
      })
      .addCase(fetchStocks.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload as string;
      });
  },
});

export default stocksSlice.reducer;
